<div class="app-main__inner">

    <div class="app-page-title">
        <div class="page-title-wrapper">
            <div class="page-title-heading">
                <div class="page-title-icon">
                    <i class="pe-7s-config icon-gradient bg-happy-fisher"></i>
                </div>
                <div>
                    Custom Masters
                    <div class="page-title-subheading">Create and manage your own master types and values.</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Alerts -->
    <div *ngIf="successMessage" class="alert alert-success alert-dismissible py-2 px-3 mb-3">
        {{ successMessage }}
        <button type="button" class="btn-close" (click)="successMessage=''"></button>
    </div>
    <div *ngIf="errorMessage" class="alert alert-danger py-2 px-3 mb-3">{{ errorMessage }}</div>

    <!-- Two-panel layout -->
    <div class="row g-3 align-items-start">

        <!-- LEFT: Level 1 list -->
        <div class="col-md-4">
            <div class="card h-100">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <span class="fw-semibold">Masters <span class="badge bg-secondary ms-1">{{ masters.length }}</span></span>
                    <button class="btn btn-primary btn-sm" (click)="openAddL1()">
                        <i class="pe-7s-plus me-1"></i> Add Master
                    </button>
                </div>
                <div class="card-body p-0">
                    <div *ngIf="isLoadingMasters" class="text-center py-4 text-muted">
                        <span class="spinner-border spinner-border-sm me-2"></span> Loading...
                    </div>
                    <div *ngIf="!isLoadingMasters && masters.length === 0" class="text-center py-5 text-muted small">
                        No masters yet.<br>Click <strong>+ Add Master</strong> to create one.
                    </div>
                    <ul class="master-list" *ngIf="!isLoadingMasters && masters.length > 0">
                        <li *ngFor="let m of masters"
                            class="master-item"
                            [class.master-item--active]="selectedMaster?._id === m._id"
                            (click)="selectMaster(m)">
                            <span class="master-item__name">
                                <i class="pe-7s-folder me-2 text-primary" style="font-size:0.95rem;"></i>
                                {{ m.masterName }}
                                <span class="badge rounded-pill ms-1" style="font-size:0.65rem;"
                                    [ngClass]="{
                                        'bg-primary-subtle text-primary': m.userTypeScope === 'internal',
                                        'bg-success-subtle text-success': m.userTypeScope === 'external',
                                        'bg-secondary-subtle text-secondary': !m.userTypeScope || m.userTypeScope === 'none',
                                        'bg-danger-subtle text-danger': m.userTypeScope === 'disabled'
                                    }">
                                    {{ m.userTypeScope === 'internal' ? 'Internal' : m.userTypeScope === 'external' ? 'External' : m.userTypeScope === 'disabled' ? 'None' : 'All' }}
                                </span>
                            </span>
                            <span class="master-item__actions">
                                <button class="btn btn-sm btn-outline-secondary py-0 px-1"
                                    title="Edit" (click)="openEditL1(m); $event.stopPropagation()">
                                    <i class="pe-7s-pen"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-danger py-0 px-1"
                                    title="Remove" (click)="deactivateL1(m); $event.stopPropagation()">
                                    <i class="pe-7s-trash"></i>
                                </button>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- RIGHT: Level 2 values -->
        <div class="col-md-8">
            <div class="card h-100">

                <!-- Empty state: no master selected -->
                <ng-container *ngIf="!selectedMaster">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                        <i class="pe-7s-folder" style="font-size:3rem;opacity:0.25;"></i>
                        <div class="mt-2">← Select a master to view and manage its values</div>
                    </div>
                </ng-container>

                <!-- Master selected -->
                <ng-container *ngIf="selectedMaster">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <div>
                            <span class="text-muted small">Masters /</span>
                            <span class="fw-semibold ms-1">{{ selectedMaster.masterName }}</span>
                            <span *ngIf="selectedMaster.description" class="text-muted ms-2 small">— {{ selectedMaster.description }}</span>
                        </div>
                        <button class="btn btn-primary btn-sm" (click)="openAddL2()">
                            <i class="pe-7s-plus me-1"></i> Add {{ selectedMaster.fieldLabel }}
                        </button>
                    </div>

                    <div class="card-body p-0">
                        <div *ngIf="isLoadingValues" class="text-center py-4 text-muted">
                            <span class="spinner-border spinner-border-sm me-2"></span> Loading...
                        </div>
                        <div *ngIf="!isLoadingValues && values.length === 0" class="text-center py-5 text-muted small">
                            No values yet for <strong>{{ selectedMaster.masterName }}</strong>.<br>
                            Click <strong>+ Add {{ selectedMaster.fieldLabel }}</strong> to add the first one.
                        </div>
                        <table *ngIf="!isLoadingValues && values.length > 0"
                            class="table table-hover align-middle mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th class="ps-3" style="width:44px">#</th>
                                    <th>{{ selectedMaster.fieldLabel | uppercase }}</th>
                                    <th>ADDED ON</th>
                                    <th style="width:100px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let v of values; let i = index">
                                    <td class="ps-3 text-muted">{{ i + 1 }}</td>
                                    <td class="fw-medium">{{ v.value }}</td>
                                    <td class="text-muted small">{{ v.createdAt | date:'dd MMM yyyy' }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-secondary py-0 px-2 me-1"
                                            (click)="openEditL2(v)" title="Edit">
                                            <i class="pe-7s-pen"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-danger py-0 px-2"
                                            (click)="deactivateL2(v)" title="Remove">
                                            <i class="pe-7s-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="!isLoadingValues && values.length > 0"
                            class="px-3 py-2 text-muted small border-top">
                            Showing {{ values.length }} {{ values.length === 1 ? 'record' : 'records' }}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>


<!-- Add L1 Modal -->
<div class="modal fade" tabindex="-1" aria-hidden="true" #addL1Modal>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add Master</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="errorMessage" class="alert alert-danger py-2 px-3 mb-3 small">{{ errorMessage }}</div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Master Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="newL1.masterName"
                        placeholder="e.g. Role Master, Department Master" maxlength="80" />
                    <div class="form-text">This is the Level 1 category name.</div>
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Field Label</label>
                    <input type="text" class="form-control" [(ngModel)]="newL1.fieldLabel"
                        placeholder="e.g. Role Name (defaults to Master Name if blank)" maxlength="60" />
                    <div class="form-text">Column header shown for Level 2 values.</div>
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Description</label>
                    <input type="text" class="form-control" [(ngModel)]="newL1.description"
                        placeholder="Optional short description" maxlength="200" />
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold d-block">Applies To</label>
                    <div class="d-flex gap-4 flex-wrap">
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="addScopeNone" name="addScope"
                                [(ngModel)]="newL1.userTypeScope" value="none" />
                            <label class="form-check-label" for="addScopeNone">All users</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="addScopeInternal" name="addScope"
                                [(ngModel)]="newL1.userTypeScope" value="internal" />
                            <label class="form-check-label" for="addScopeInternal">Internal only</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="addScopeExternal" name="addScope"
                                [(ngModel)]="newL1.userTypeScope" value="external" />
                            <label class="form-check-label" for="addScopeExternal">External only</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="addScopeDisabled" name="addScope"
                                [(ngModel)]="newL1.userTypeScope" value="disabled" />
                            <label class="form-check-label" for="addScopeDisabled">None</label>
                        </div>
                    </div>
                    <div class="form-text">Controls which user types see this master as a group dropdown in User Master.</div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="saveL1()" [disabled]="isSavingL1">
                    <span *ngIf="isSavingL1"><span class="spinner-border spinner-border-sm me-2"></span>Saving...</span>
                    <span *ngIf="!isSavingL1">Save Master</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Edit L1 Modal -->
<div class="modal fade" tabindex="-1" aria-hidden="true" #editL1Modal>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edit Master</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="errorMessage" class="alert alert-danger py-2 px-3 mb-3 small">{{ errorMessage }}</div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Master Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editL1.masterName" maxlength="80" />
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Field Label</label>
                    <input type="text" class="form-control" [(ngModel)]="editL1.fieldLabel" maxlength="60" />
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Description</label>
                    <input type="text" class="form-control" [(ngModel)]="editL1.description" maxlength="200" />
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold d-block">Applies To</label>
                    <div class="d-flex gap-4 flex-wrap">
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="editScopeNone" name="editScope"
                                [(ngModel)]="editL1.userTypeScope" value="none" />
                            <label class="form-check-label" for="editScopeNone">All users</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="editScopeInternal" name="editScope"
                                [(ngModel)]="editL1.userTypeScope" value="internal" />
                            <label class="form-check-label" for="editScopeInternal">Internal only</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="editScopeExternal" name="editScope"
                                [(ngModel)]="editL1.userTypeScope" value="external" />
                            <label class="form-check-label" for="editScopeExternal">External only</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="editScopeDisabled" name="editScope"
                                [(ngModel)]="editL1.userTypeScope" value="disabled" />
                            <label class="form-check-label" for="editScopeDisabled">None</label>
                        </div>
                    </div>
                    <div class="form-text">Controls which user types see this master as a group dropdown in User Master.</div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="updateL1()" [disabled]="isSavingL1">
                    <span *ngIf="isSavingL1"><span class="spinner-border spinner-border-sm me-2"></span>Saving...</span>
                    <span *ngIf="!isSavingL1">Update Master</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Add L2 Modal -->
<div class="modal fade" tabindex="-1" aria-hidden="true" #addL2Modal>
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add {{ selectedMaster?.fieldLabel }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="errorMessage" class="alert alert-danger py-2 px-3 mb-3 small">{{ errorMessage }}</div>
                <div class="mb-2">
                    <label class="form-label fw-semibold">{{ selectedMaster?.fieldLabel }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="newL2Value"
                        [placeholder]="'e.g. ' + (selectedMaster?.fieldLabel || 'Value')" maxlength="100"
                        (keyup.enter)="saveL2()" />
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="saveL2()" [disabled]="isSavingL2">
                    <span *ngIf="isSavingL2"><span class="spinner-border spinner-border-sm me-2"></span></span>
                    <span *ngIf="!isSavingL2">Add</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Edit L2 Modal -->
<div class="modal fade" tabindex="-1" aria-hidden="true" #editL2Modal>
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edit {{ selectedMaster?.fieldLabel }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="errorMessage" class="alert alert-danger py-2 px-3 mb-3 small">{{ errorMessage }}</div>
                <div class="mb-2">
                    <label class="form-label fw-semibold">{{ selectedMaster?.fieldLabel }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editL2.value" maxlength="100"
                        (keyup.enter)="updateL2()" />
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="updateL2()" [disabled]="isSavingL2">
                    <span *ngIf="isSavingL2"><span class="spinner-border spinner-border-sm me-2"></span></span>
                    <span *ngIf="!isSavingL2">Update</span>
                </button>
            </div>
        </div>
    </div>
</div>
